import Error from '../Error';

const Template = ({ error, ...rest }) => {
  if (error) return <Error {...error} {...rest} />;
  return null;
};

export default Template;
